import type { OrderLineItem as SwOrderLineItem } from '@hubblecommerce/hubble/platforms/shopware/api-client'
import type { HblOrderLineItem } from '@/utils/types'
import { hblMapMedia, hblMapOrderLineItemDownloads } from '#imports'

export function hblMapOrderLineItem (swOrderLineItem: SwOrderLineItem): HblOrderLineItem {
    return {
        id: swOrderLineItem.id,
        // @ts-ignore
        itemId: swOrderLineItem.referencedId,
        parentId: swOrderLineItem.parentId ?? null,
        identifier: swOrderLineItem.identifier,
        sku: swOrderLineItem.payload?.productNumber,
        name: swOrderLineItem.label,
        quantity: swOrderLineItem.quantity,
        type: swOrderLineItem.type,
        promotions: swOrderLineItem.payload?.promotions,
        promotionType: swOrderLineItem.payload?.line_item_type,
        promotionName: swOrderLineItem.payload?.promotion_name,
        giftPrice: swOrderLineItem.payload?.meteorFreeGiftOriginalPrice,
        // @ts-ignore
        media: hblMapMedia(swOrderLineItem.cover),
        options: swOrderLineItem.payload?.options,
        deliveryTimeCustomFields: swOrderLineItem.payload?.deliveryTimeCustomFields,
        // @ts-ignore
        price: swOrderLineItem.totalPrice,
        unitPrice: swOrderLineItem.unitPrice,
        // @ts-ignore
        listPrice: swOrderLineItem.priceDefinition?.listPrice ?? null,
        isGreetingCard: swOrderLineItem.payload?.repertusIsGreetingCard,
        greetingCardText: swOrderLineItem.payload?.repertusGreetingCardText,
        children: swOrderLineItem.payload?.productSet,
        packUnit: swOrderLineItem?.payload?.packUnit,
        payload: swOrderLineItem.payload,
        // @ts-ignore
        ...(swOrderLineItem?.downloads?.length > 0 && { downloads: hblMapOrderLineItemDownloads(swOrderLineItem?.downloads) })
    }
}
